import React from 'react';
import LegalPage from '../legal/LegalPage';

const PrivacyPage: React.FC = () => <LegalPage doc='privacy' />;

export default PrivacyPage;
